import { ValueOf } from '@/types/util';

export const applicableType = {
  IMMEDIATELY: '即時',
  RESERVATION: '日付指定',
} as const;

export type ApplicableTypeKey = keyof typeof applicableType;
export type ApplicableTypeValue = ValueOf<typeof applicableType>;

export const applicableTypeKeys = Object.keys(applicableType) as ApplicableTypeKey[];

/** v-select用items */
export const applicableTypeItems = applicableTypeKeys
  .map((key) => ({
    title: applicableType[key],
    value: key,
  }));
